module.exports = __webpack_public_path__ + "img/align-left.2d28aabe.svg";